import { PspContext } from "@/config/contexts";
import { useContext, useEffect, useMemo, useState } from "react";
import ListItemMobile from "@/components/listItemMobile/ListItemMobile";
import { getFileFAIcon } from "@/config/utils";
import { CircularLetter, getCircularLetters } from "@/api/openapi";
import { showTranslated, translate } from "@/config/translator";
import { onDownloadCircularLetter } from "./homeUtils";
import { toast } from "react-toastify";
import { FullScreenSpinner } from "@/components/fullScreenSpinner/FullScreenSpinner";
import { HomeMobileTopBar } from "./homeMobile/homeMobileTopBar";

export default function HomeMobile() {
  // -----------------------------------------------------------------------------
  // GENERAL
  // -----------------------------------------------------------------------------
  const { lang } = useContext(PspContext);

  // -----------------------------------------------------------------------------
  // STATES
  // ----------------------------------------------------------------------------
  const [circularLetters, setCircularLetters] = useState<CircularLetter[]>();
  const [isLoadingCircularLetters, setIsLoadingCircularLetters] =
    useState(true);

  // -----------------------------------------------------------------------------
  // FETCH INITIAL DATA
  // -----------------------------------------------------------------------------
  useEffect(() => {
    getCircularLetters().then(
      ({ data, error }) => {
        if (error) {
          toast(translate("couldntLoadCircularLetters", lang));
          throw error;
        }
        setCircularLetters(data);
        setIsLoadingCircularLetters(false);
      },
    );
  }, [lang]);

  // -----------------------------------------------------------------------------
  // MEMOIZED VALUES
  // -----------------------------------------------------------------------------
  const isLoading = isLoadingCircularLetters;

  if (isLoading) {
    return (
      <>
        <HomeMobileTopBar />
        <FullScreenSpinner />
      </>
    );
  }

  return (
    <>
      <HomeMobileTopBar />
      <div className="p-6">
        {circularLetters && circularLetters.length ? (
          circularLetters?.map((circularLetter) => (
            <ListItemMobile
              key={`circular-letters-mobile-${circularLetter.id}`}
              onClick={() => onDownloadCircularLetter(circularLetter.id, lang)}
              icon={getFileFAIcon("application/pdf")}
              primaryText={showTranslated(circularLetter.name, lang)}
              secondaryText={new Date(
                circularLetter.creationDate,
              ).toLocaleString()}
            />
          ))
        ) : circularLetters === undefined ? (
          <p className="text-font-secondary">{translate("loading", lang)}</p>
        ) : (
          circularLetters.length === 0 && (
            <p className="text-font-secondary">
              {translate("noCircularLetters", lang)}
            </p>
          )
        )}
      </div>
    </>
  );
}
